export default __webpack_public_path__ + "static/media/13.a49922a0.jpg";